import { useLocation } from 'react-router-dom';

import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { CmsApiSubsite } from 'modules/cms/api/types/CmsApiSubsite';

type Args = {
  cmsApiPage: CmsApiPage | undefined;
};

type ContentSubsiteLocationState = {
  subsite: CmsApiSubsite;
};

export function useCmsApiPageSubsite({
  cmsApiPage,
}: Args): CmsApiSubsite | undefined {
  const location = useLocation();
  const state = location.state as ContentSubsiteLocationState;

  if (!state?.subsite) return cmsApiPage?.subsite;

  return {
    ...state.subsite,
    defaultSearchType: cmsApiPage?.subsite.defaultSearchType,
  } as CmsApiSubsite;
}
